export default "__VITE_ASSET__CEPRkkap__"